import { Menu, MenuButton, MenuItem, MenuList, Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function OrgMenu(props: {
  orgs: any[];
  selectedOrgId: string;
  setSelectedOrgId: (orgId: string) => void;
}) {
  const org = props.orgs.find((x) => x.key === props.selectedOrgId);
  const orgName = org?.value || '';
  const { t } = useTranslation();
  return (
    <Menu>
      <MenuButton
        variant="secondary"
        size="md"
        width="260px"
        overflowX="hidden"
      >
        <Text maxWidth="220px" overflow="hidden" textOverflow="ellipsis">
          {t('common.label.org')}:&nbsp;{orgName}
        </Text>
      </MenuButton>
      <MenuList
        width="max-content"
        minWidth="260px"
        maxHeight="400px"
        overflowX="hidden"
        overflowY="scroll"
      >
        {props.orgs.map((org) => {
          const onClick = props.setSelectedOrgId.bind(null, org.key);
          return (
            <MenuItem onClick={onClick} key={org.key} cursor="pointer">
              {org.value}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}
